import type { RouteRecordRaw } from "vue-router";

const router: RouteRecordRaw[] = [
  {
    path: "/shifts/",
    name: "ShiftScheduleTemplateList",
    component: () => import("@/modules/shift/views/ShiftScheduleTemplateList.vue"),
    meta: {
      rights: ["shiftSchedule.admin"],
    },
  },
  {
    path: "/shifts/:id(\\d+)?",
    name: "ShiftScheduleTemplate",
    component: () => import("@/modules/shift/views/ShiftScheduleTemplate.vue"),
    props(route) {
      return {
        id: Number.isNaN(Number(route.params.id)) ? undefined : Number(route.params.id),
      };
    },
    meta: {
      rights: ["shiftSchedule.admin"],
    },
  },
  {
    path: "/shifts/new",
    name: "ShiftScheduleTemplateNew",
    component: () => import("@/modules/shift/views/ShiftScheduleTemplate.vue"),
    meta: {
      rights: ["shiftSchedule.admin"],
    },
  },
  {
    path: "/shiftScheduleNew/:ccId(\\d+)?/:date?",
    name: "ShiftScheduleNew",
    component: () => import("@/modules/shift/views/ShiftSchedule.vue"),
    props(route) {
      const date = new Date(route.params.date.toString());
      return {
        ccId:
          !route.params.ccId || Number.isNaN(Number(route.params.ccId))
            ? undefined
            : Number(route.params.ccId),
        date: !route.params.date || date.toString() === "Invalid Date" ? undefined : date,
      };
    },
    meta: {
      rights: ["shiftSchedule.admin"],
    },
  },
  {
    path: "/shiftScheduleNew/ccOverview",
    name: "ShiftScheduleCCOverview",
    component: () => import("@/modules/shift/views/ShiftScheduleCCOverview.vue"),
    meta: {
      rights: ["shiftSchedule.admin"],
    },
  },
];

export default router;
